import { render, staticRenderFns } from "./AcctPolicyHelpList.vue?vue&type=template&id=4b058caa&"
import script from "./AcctPolicyHelpList.vue?vue&type=script&lang=js&"
export * from "./AcctPolicyHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports